import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=a50fa752&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=a50fa752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50fa752",
  null
  
)

export default component.exports